<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark fab small v-on="on" v-bind="attrs" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </template>
      <span>Go to Previous Page</span>
    </v-tooltip>
    <v-row>
      <v-col lg="4" cols="12" v-if="authPermissions.has('consumer_loans:create')">
        <v-toolbar color="primary" dark>
          Add Transaction
        </v-toolbar>
        <create-consumer-loan-transaction :propConsumerId="consumerId" :propConsumerLoanId="consumerLoanId" />
      </v-col>
      <v-col lg="8" cols="12">
        <v-toolbar color="primary" dark>
          Transactions
        </v-toolbar>
        <index-consumer-loan-transaction :propConsumerId="consumerId" :propConsumerLoanId="consumerLoanId"
          @edit="initEditTransaction" />
      </v-col>
    </v-row>
    <v-dialog dismissable max-width="600px" eager class="pa-0" v-model="editTransaction">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title>Edit</v-card-title>
        </v-toolbar>

        <edit-consumer-loan-transaction @close-dialog="editTransaction = false" :propConsumerId="consumerId"
          :propConsumerLoanId="consumerLoanId" :propConsumerLoanTransaction="consumerLoanTransaction" />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'consumer-loan-transaction',
  components: {
    indexConsumerLoanTransaction: () => import('@/views/dashboard/components/consumer-loan-transactions/Index'),
    editConsumerLoanTransaction: () => import('@/views/dashboard/components/consumer-loan-transactions/Edit'),
    createConsumerLoanTransaction: () => import('@/views/dashboard/components/consumer-loan-transactions/Create'),
  },
  data() {
    return {
      consumerId: this.$route.params.consumer,
      consumerLoanId: this.$route.params.consumerLoan,
      editTransaction: false,
      consumerLoanTransaction: {},
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditTransaction(data) {
      this.consumerLoanTransaction = data
      this.editTransaction = true
    },
  },
}
</script>
